const CONFIG = "config";
import Enigma from "../services/encryption.service";

const TokenService = {
  saveConfig(obj) {
    const config = Enigma.encryptObj(obj);

    sessionStorage.setItem(CONFIG, config);
  },
  getConfig(option) {
    if (sessionStorage.getItem(CONFIG)) {
      let res = Enigma.decryptObj(sessionStorage.getItem(CONFIG));
      return res[option];
    }
  },

  removeCofnig() {
    sessionStorage.removeItem(CONFIG);
  },
};

export { TokenService };
